import { useEffect, useState } from 'react'

export const BREAK_POINT = {
  sm: 360,
  md: 768,
  lg: 1200,
}

interface BreakPoint {
  sm: boolean
  md: boolean
  lg: boolean
}

const useBreakPoint = () => {
  const [breakPoint, setBreakPoint] = useState<BreakPoint>({
    sm: false,
    md: false,
    lg: false,
  })
  const [width, setWidth] = useState<number>(0)

  const handleResize = () => {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [width])

  useEffect(() => {
    if (width >= BREAK_POINT.sm) {
      setBreakPoint(prev => ({
        ...prev,
        sm: true,
        md: false,
        lg: false,
      }))
    }

    if (width >= BREAK_POINT.md) {
      setBreakPoint(prev => ({
        ...prev,
        sm: true,
        md: true,
        lg: false,
      }))
    }

    if (width >= BREAK_POINT.lg) {
      setBreakPoint(prev => ({
        ...prev,
        sm: true,
        md: true,
        lg: true,
      }))
    }
  }, [width])

  return breakPoint
}

export default useBreakPoint
